package br.com.texeratx.boardgametimeapp.core.storage

import br.com.texeratx.boardgametimeapp.core.i18n.AppLanguage
import kotlinx.browser.localStorage

class JsLanguageStorage : LanguageStorage {

    override suspend fun saveLanguage(language: AppLanguage) {
        localStorage.setItem("app_language", language.code)
    }

    override suspend fun getLanguage(): AppLanguage? {
        val code = localStorage.getItem("app_language") ?: return null
        return AppLanguage.entries.find { it.code == code }
    }
}

actual fun provideLanguageStorage(): LanguageStorage = JsLanguageStorage()
